namespace $.$$ {

	function hitalama_process_monitor_detail_widget_title( process: $shm_hitalama_process< any > ) {
		if( process.method_name !== 'run_auto' ) return ''

		const host = process.host as {
			widget?: () => {
				title(): string
			}
		} | undefined

		const widget = host?.widget?.()
		if( !widget ) return ''

		return widget.title() || ''
	}

	export class $shm_hitalama_process_monitor_detail extends $.$shm_hitalama_process_monitor_detail {

		method_title() {
			return this.Process().method_title()
		}

	}

	export class $shm_hitalama_process_monitor_detail_process extends $.$shm_hitalama_process_monitor_detail_process {

		method_title() {
			const process = this.calls()[0]
			if( !process ) return this.key()
			if( process.data().label ) return process.data().label!

			const widget_title = hitalama_process_monitor_detail_widget_title( process )
			if( widget_title ) return widget_title

			const args = process.args.map( arg => this.short_value( arg ) ).join( ', ' )
			return `${ this.host_title( process.host ) }${ process.method_name }(${ args })`
		}

		@ $mol_mem
		calls() {
			return [ ... this.$.$shm_hitalama_process.calls_by_key( this.key() ) ].reverse()
		}

		host_title( host: object | undefined ) {
			if( !host ) return ''

			const full = `${ host }.`
			const widgets = [ ... full.matchAll( /(?:^|\.)(Widget<[^>]+>)(?=\.|$)/g ) ]
			const widget = widgets[ widgets.length - 1 ]
			if( widget ) return `${ widget[1] }.`

			return ''
		}

		short_value( value: unknown ) {
			if( typeof value === 'string' ) return JSON.stringify( value.length > 24 ? value.slice( 0, 21 ) + '...' : value )
			if( typeof value === 'number' || typeof value === 'boolean' || value === null ) return String( value )
			if( value === undefined ) return 'undefined'

			const title = ( value as { constructor?: { name?: string } } )?.constructor?.name
			return title && title !== 'Object' ? title : '{...}'
		}

	}

}
